import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';

import { FileService } from '@services/file.service';
import { UiService } from '@services/ui.service';
import { FilesLists } from '@classes/file/files-lists';
import { FileSource } from '@enums/file-source.enum';
import { NavService } from '@services/nav.service';
import { NavLink } from '@classes/nav-link';
import { UserService } from '@services/user.service';
import { ProviderType } from '@enums/provider-type.enum';
import { AuthService } from '@services/auth.service';
import { LicenceRoleType } from '@enums/licence-role-type.enum';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
    selector: 'app-upload-list',
    templateUrl: './upload-list.component.html',
    styleUrls: ['./upload-list.component.scss']
})
export class UploadListComponent implements OnInit, OnDestroy {
    @Input() tabIndex: number = 0;

    private subscription = new Subscription();
    private systemSubscription = new Subscription();
    private hasSystem = false;

    isLoading: boolean;
    filesLists: FilesLists;
    fileSource = FileSource;
    paramLink: NavLink;
    doesShowParamLink: boolean;
    provider: ProviderType;
    role: LicenceRoleType;

    constructor(
        private fileSrv: FileService,
        private uiSrv: UiService,
        private navSrv: NavService,
        private userSrv: UserService,
        private authSrv: AuthService,
    ) {
        const user = this.authSrv.getDecodedToken();
        this.provider = user.provider_category;
        this.role = user.role;
    }

    ngOnInit() {
        this.initSubscriptions();
        this.paramLink = this.navSrv.getLinkFromRoute(['parameters', 'config-provider'], 'settings');
    }

    onGetFiles(): void {
        this.isLoading = true;
        this.fileSrv.getFiles().subscribe(() => this.isLoading = false);
    }

    private initSubscriptions(): void {
        this.onGetFiles();

        this.subscription.add(this.fileSrv.filesListsChanged
            .subscribe(filesListsFromSrv => {
                this.filesLists = filesListsFromSrv;
            })
        );

        this.subscription.add(this.userSrv.userParametersSubject
            .subscribe(() => {
                this.doesShowParamLink = !this.userSrv.providerTypeMatches(ProviderType.bbc);
            })
        );

        this.subscription.add(this.uiSrv.loadingStateChanged
            .subscribe(loadingState => {
                this.isLoading = loadingState;
            })
        );
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        this.systemSubscription.unsubscribe();
    }

    tabSelected(event: MatTabChangeEvent): void {
        if (event.index === 2 && !this.hasSystem)
        {
            this.hasSystem = true;
            this.systemSubscription = this.fileSrv.getSystems()
            .subscribe(files => this.filesLists.systemFiles = files);
        }
    }
}
